import React from 'react';
import PropTypes from 'prop-types';

import AnimateWeightDisplay from '../animated-weight-display';
import { useAutoReadFromScale } from '../../hooks/use-auto-read-from-scale';

const AutoWeight = ({ autoReadScale$, onScaleRead, weight = 0, children, isDisabled = false }) => {
  useAutoReadFromScale(autoReadScale$, onScaleRead, isDisabled);

  return <AnimateWeightDisplay endWeight={weight}>{children}</AnimateWeightDisplay>;
};

AutoWeight.propTypes = {
  autoReadScale$: PropTypes.any.isRequired,
  onScaleRead: PropTypes.func.isRequired,
  weight: PropTypes.number,
  children: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default AutoWeight;
